import { girls } from "./girls";
import { boys } from "./boys"
export const dogs = [
    {title:"Boys", url:"dogs/boys", submenu:boys},
    {title:"Girls", url:"dogs/girls", submenu:girls},
    {title:"  Available", url:"dogs/available"},
];